// Centralized style definitions.
// All component styles reference these constants so recoloring is a single-file change
// (here for class names, globals.css for color values).

export const input =
  "flex-1 min-w-0 rounded-md border border-border bg-surface-light px-3 py-[6px] text-sm text-foreground placeholder-muted focus:outline-none focus:border-cyan focus:ring-1 focus:ring-cyan";

export const fieldRow = "flex items-center gap-3";

export const label = "text-sm font-medium text-amber shrink-0 w-36";

export const btnPrimary =
  "bg-accent text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-accent-hover disabled:opacity-50 transition-colors shadow-md shadow-accent/20";

export const btnAuxiliary =
  "bg-accent-dim text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-accent-dim-hover disabled:opacity-50 transition-colors shadow-md shadow-accent-dim/20";

export const card =
  "rounded-lg border border-border bg-surface p-6 space-y-4";

export const pageTitle = "text-xl font-semibold text-purple mb-6";

export const statusIcon = "inline-flex shrink-0 w-[18px] h-[18px] mr-2";

export const modalOverlay =
  "fixed inset-0 z-40 flex items-center justify-center bg-black/60";

export const modalContent =
  "rounded-lg border border-border bg-surface p-6 space-y-4 w-full max-w-md shadow-xl";
